<span *ngIf="operation?.operationType === 'SELL'" translate data-qa="operation-type"
  >kkms.kkm.report.operation.operationType.sell</span
>
<span *ngIf="operation?.operationType === 'BUY'" translate data-qa="operation-type"
  >kkms.kkm.report.operation.operationType.buy</span
>
<span *ngIf="operation?.operationType === 'SELL_RETURN'" translate data-qa="operation-type"
  >kkms.kkm.report.operation.operationType.sell_return</span
>
<span *ngIf="operation?.operationType === 'BUY_RETURN'" translate data-qa="operation-type"
  >kkms.kkm.report.operation.operationType.buy_return</span
>
